const ROLES = {
  SUPER_ADMIN: "SUPER_ADMIN",
  TENANT_ADMIN: "TENANT_ADMIN",
  ADMIN: "ADMIN", // Matches backend database role
  DOCTOR: "DOCTOR",
};

export default ROLES;
